import { z } from "zod";

export const AnalyzeTypeSchema = z.enum([
  "COMPUTE_ALL",
  "COMPUTE_FEATURES",
  "COMPUTE_PREVIEW",
  "COMPUTE_GLTF",
  "COMPUTE_GRAPH",
  "COMPUTE_EMBEDDINGS",
  "COMPUTE_TOPOLIGICAL_EMBEDDING",
  "COMPUTE_FLAT_PATTERN",
  "COMPUTE_WELD_LENGTH",
]);

export type AnalyzeTypeType = z.infer<typeof AnalyzeTypeSchema>;
